module.exports = __webpack_public_path__ + "static/img/icon-new-left.a286b020.svg";